<div class="d-flex flex-wrap gap-3" #container>
    <mat-form-field>
        <mat-label>Zoeken...</mat-label>
        <input type="text" [formControl]="fcSearch" matInput/>
    </mat-form-field>
    <a *ngFor="let entity of items"
       class="d-flex flex-column"
       [class.red]="!entity.entity.entities[0]?.project_id"
       routerLink="/{{Routenames.Projects}}/{{entity.entity.entities[0]?.project_id}}"
       [queryParams]="{drawing: entity.entity.entities[0]?.drawings[0]?.id}">
        <img [src]="entity.blob | safeSrc"/>
        <small>{{entity.entity.created_at | date : 'EE d MMM \'\'yy H:mm'}} - {{entity.entity.entities[0]?.name}}</small>
    </a>
</div>
<div class="next" (click)="next()">
    Volgende
</div>
